import JsCookies from "js-cookie";

import { COOKIE_KEYS_MAP } from "~/common/constants";

const initState = { isSign: null, userDetail: undefined, addressInfo: undefined };

// 登录态区分三种不同的值
// null-不确定(仅服务端)、false-未登录、true-已登录
const reducer = (state = initState, action) => {
  //todo capi/personal/user/login-status/get 这个接口没正确返回 临时设置成true 方便联调
  // return { ...state, ...{ isSign: true, userDetail: action.payload } };
  switch (action.type) {
    case "UPDATE_SIGN_STATE":
      if (!action.payload) {
        return { ...state, ...{ isSign: null, userDetail: undefined } };
      } else {
        return { ...state, ...{ isSign: true, userDetail: action.payload } };
      }
    case "CLEAR_SIGN_STATE": {
      // 退出登录删除上次用户选择的地址
      const countryId = JsCookies.get(COOKIE_KEYS_MAP.CountryId);
      JsCookies.remove(`${COOKIE_KEYS_MAP.previousSelectAddress}_${countryId}`);
      return { ...state, ...{ isSign: false, userDetail: undefined } };
    }
    case "ADD_LOGIN_DATA":
      return { ...state, ...action.payload };
    case "UPDATE_ADDRESS_INFO":
      return { ...state, addressInfo: action.payload };
    default:
      return state;
  }
};

export default reducer;
